import usePost from "./usePost";

const useCustomContactCTA = () => {
  const { customContactCTA, customContactCTAIcon } = usePost();

  if (!customContactCTA) {
    return null;
  }

  const [title, description, btnText, btnLink ] = customContactCTA;

  return { title, description, btnText, btnLink, iconPath: customContactCTAIcon?.publicURL};
}

export default useCustomContactCTA;
